module.exports = __webpack_public_path__ + "img/Apoptosis-LUCA_10X_LU.38b86b14.png";